import React from 'react'
import {
  ButtonGroupItemStyled,
  ButtonGroupStyled,
} from '@core/Components/Buttons/ButtonGroup.styles'
import type { RaceCodesLowerCase } from '@core/Areas/Racing/Types/MeetingInformation'

export const CodeSelectionFilter: React.FC<{
  racesSelected: boolean
  trotsSelected: boolean
  dogsSelected: boolean
  selectionChangedCallback({ field, value }: { field: RaceCodesLowerCase; value: boolean }): void
  testId: string
}> = ({ racesSelected, trotsSelected, dogsSelected, selectionChangedCallback, testId }) => {
  const toggleButtonHandler = (field: RaceCodesLowerCase, value: boolean) => {
    selectionChangedCallback({ field, value })
  }

  return (
    <ButtonGroupStyled>
      <ButtonGroupItemStyled
        color='toggle'
        onClick={() => toggleButtonHandler('races', !racesSelected)}
        selected={racesSelected}
        aria-label='Races'
        data-tid-races={testId}
      >
        Races
      </ButtonGroupItemStyled>

      <ButtonGroupItemStyled
        color='toggle'
        onClick={() => toggleButtonHandler('trots', !trotsSelected)}
        selected={trotsSelected}
        aria-label='Trots'
        data-tid-trots={testId}
      >
        Trots
      </ButtonGroupItemStyled>

      <ButtonGroupItemStyled
        color='toggle'
        onClick={() => toggleButtonHandler('dogs', !dogsSelected)}
        selected={dogsSelected}
        aria-label='Dogs'
        data-tid-dogs={testId}
      >
        Dogs
      </ButtonGroupItemStyled>
    </ButtonGroupStyled>
  )
}
